import {
  Outlet,
  RouterProvider,
  createBrowserRouter,
  useLocation,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import CPLogo from "./assets/logos/cp.png";
import GetStarted from "./screens/GetStarted";
import SelectOptions from "./screens/SelectOptions";
import StartScan from "./screens/StartScan";
import Scan from "./screens/Scan";
import Result from "./screens/Result";
import DownloadReport from "./screens/DownloadReport";

const Header = () => {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  document.body.dir = i18n.dir();

  return (
    <main className="min-h-dvh flex flex-col relative bg-[#fcfcfc] overflow-hidden">
      {pathname !== "/" && (
        <>
          {pathname !== "/scan" && (
            <>
              <div className="absolute top-[8%] pointer-events-none right-[12%] -translate-y-1/2 translate-x-1/2 size-80 sm:size-[40rem] rounded-full bg-radial-gradient text-[#791ce1]/30" />
              <div className="absolute top-[15%] -left-[10%] pointer-events-none -translate-x-1/2 size-[32rem] sm:size-[80rem] rounded-full bg-radial-gradient text-[#1545d6]/35" />
            </>
          )}
          <img
            src={CPLogo}
            alt="VendorLogo"
            className="self-center shrink-0 my-8 sm:my-16 max-h-[4.5rem] max-w-[10rem] sm:max-h-[8.5rem] sm:max-w-[18rem] relative z-10"
          />
        </>
      )}
      <Outlet />
    </main>
  );
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Header />,
    children: [
      { index: true, element: <GetStarted /> },
      { path: "/select-options", element: <SelectOptions /> },
      { path: "/start-scan", element: <StartScan /> },
      { path: "/scan", element: <Scan /> },
      { path: "/result", element: <Result /> },
      { path: "/report", element: <DownloadReport /> },
    ],
  },
]);

const App = () => <RouterProvider router={router} />;

export default App;
